export const GET_CAMPAIGN_METRICS = 'GET_CAMPAIGN_METRICS'
export const GET_CAMPAIGN_METRICS_SUCCESS = 'GET_CAMPAIGN_METRICS_SUCCESS'
export const GET_CAMPAIGN_METRICS_FAILURE = 'GET_CAMPAIGN_METRICS_FAILURE'
